export default "__VITE_ASSET__DvtqcGFb__"